export const GENRES = [
    'Blues',
    'Classical',
    'Country',
    'Electronic / DJ',
    'Folk / Acoustic',
    'Hip-Hop / Rap',
    'Jazz',
    'Latin',
    'Metal',
    'Pop',
    'R&B / Soul',
    'Rock',
    'Singer-Songwriter',
    'Tribute Band',
    'World Music',
    'Unclassified',
];
export const GENRE_COLORS = {
    'Blues': '#1e40af',
    'Classical': '#7c3aed',
    'Country': '#92400e',
    'Electronic / DJ': '#0891b2',
    'Folk / Acoustic': '#065f46',
    'Hip-Hop / Rap': '#1e293b',
    'Jazz': '#b45309',
    'Latin': '#b91c1c',
    'Metal': '#374151',
    'Pop': '#be185d',
    'R&B / Soul': '#7c2d12',
    'Rock': '#991b1b',
    'Singer-Songwriter': '#166534',
    'Tribute Band': '#4338ca',
    'World Music': '#0f766e',
    'Unclassified': '#6b7280',
};
export const SCRAPE_FREQUENCIES = ['daily', 'weekdays_only', 'weekends_only', 'custom'];
export const GENRE_STATUSES = ['pending', 'classified', 'unclassified', 'manual'];
export const EVENT_STATUSES = ['active', 'cancelled', 'postponed'];
export const SUGGESTION_STATUSES = ['pending', 'approved', 'rejected', 'duplicate'];
export const SCRAPE_JOB_STATUSES = ['running', 'completed', 'failed', 'partial'];
export const SCRAPE_LOG_STATUSES = ['success', 'failed', 'skipped', 'no_events_found'];
//# sourceMappingURL=genres.js.map